import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay, Navigation } from 'swiper/modules';

const VoiceOfFarmers = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const modalRef = useRef(null);
  const swiperRef = useRef(null);
  
  const videoData = [
    'https://res.cloudinary.com/dzngpgki4/video/upload/v1751041803/Voice_of_Farmer_5_d5pfw0.mp4',
    'https://res.cloudinary.com/dzngpgki4/video/upload/v1751041122/Voice_of_Farmer_1_nct42c.mp4',
    'https://res.cloudinary.com/dzngpgki4/video/upload/v1751041126/Voice_of_farmer_3_weutyf.mp4',
    'https://res.cloudinary.com/dwfdzdaxk/video/upload/v1751378226/Voice_of_Farmer_4_dqzcra.mp4',
    'https://res.cloudinary.com/dwfdzdaxk/video/upload/v1751378206/Voice_of_Farmer_2_guuqqq.mp4',
  ];
  

  const cardData = [
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750720309/image_xrfxw9.png',
      title: 'Planning & management',
      location: 'Mpumalanga, South Africa',
      description: '"Farmnet is an amazing app—it automatically generates reports for you, making farm management so much easier."',
      video: videoData[0]
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750720309/image-1_ici51n.png',
      title: 'Market',
      location: 'Bungoma Kenya',
      description: '"I have access to up-to-date market trends for the crops I grow, which helps me make better selling decisions."',
      video: videoData[1]
    },
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1750720310/image-2_xrmucc.png',
      title: 'Market',
      location: 'Kakamega, Kenya',
      description: '"Tracking my farm finances has never been easier. I can see my profits and expenses clearly now."',
      video: videoData[2]
    },
    {
      image: 'https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751371346/image-3_vcran5.png',
      title: 'SERVICE PROVIDERS',
      location: 'Farmer, Kakamega Kenya',
      description: '"The value addition services I received have enabled me to process and sell my potato chips more effectively"',
      video: videoData[3]
    },
    {
      image: 'https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751371346/image-4_oloxcg.png',
      title: 'MARKET',
      location: 'Farmer, Kakamega Kenya',
      description: '"The app has made it easier for me to sell my beans and reach more buyers.."',
      video: videoData[4]
    },
   
  ];

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const openVideoModal = (videoUrl) => {
    setSelectedVideo(videoUrl);
    document.body.style.overflow = 'hidden';
  };

  const closeVideoModal = () => {
    if (modalRef.current) {
      modalRef.current.style.transform = 'rotateY(90deg) scale(0.5)';
      modalRef.current.style.opacity = '0';
    }
    
    setTimeout(() => {
      setSelectedVideo(null);
      document.body.style.overflow = 'auto';
    }, 500);
  };

  return (
    <div className="px-4 md:pr-20  md:pl-[120px] md:pb-6 pb-5 bg-white relative">
      <h2 className="text-[10px] md:text-[36px] font-bold text-[#152C24] md:pt-2  pt-2">Voice of farmers</h2>

      <div className="flex flex-row items-end justify-between md:mt-2" style={{ lineHeight: '1.23' }}>
        <div className="flex-1 overflow-hidden">
          <div className="hidden md:block">
            {isExpanded ? (
              <p className="md:text-[36px] text-[8px] text-black mb-4 font-medium animate-fadeIn">
                Farmers report that the Farmnet app significantly enhances their productivity by providing timely weather updates, expert agricultural advice, and up-to-date market information - empowering them to make better-informed decisions. The app is also praised for facilitating direct communication with buyers, helping farmers secure better prices and receive timely payments.
              </p>
            ) : (
              <p className="md:text-[32px] text-black mb-4 font-normal animate-fadeIn">
                Farmers report that the Farmnet app significantly enhances their productivity ....
              </p>
            )}
          </div>

          <div className="md:hidden block">
            {isExpanded ? (
              <p className="text-[8px] text-black animate-fadeIn">
                Farmers report that the Farmnet app significantly enhances their productivity by providing timely weather updates, expert agricultural advice, and up-to-date market information - empowering them to make better-informed decisions. The app is also praised for facilitating direct communication with buyers, helping farmers secure better prices and receive timely payments.
              </p>
            ) : (
              <p className="text-[8px] text-black animate-fadeIn">
                Farmers highlight how Farmnet apps help them access timely weather updates, expert agricultural advice, and market information, which improves their decision-making and productivity.
              </p>
            )}
          </div>
        </div>

        <button onClick={toggleExpand} className="focus:outline-none flex-shrink-0 pr-10">
          <img 
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750287405/Expand_down_l99vrd.png" 
            alt='Expand' 
            className={`md:w-[34px] md:h-[34px] h-[10px] w-[10px] transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
          />
        </button>
      </div>

      <div className="md:mt-1 mt-2 relative">
        {/* Navigation arrows */}
        <button 
          className="absolute left-0 top-1/2 z-10 -translate-y-1/2 transform rounded-full p-1 md:p-2 hover:bg-opacity-100 transition-all duration-300"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <img 
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751994914/Arrow_drop_left_1_ukkwcn.png" 
            alt="Previous" 
            className="w-4 h-4 md:w-12 md:h-12"
          />
        </button>
        
        <button 
          className="absolute right-0 top-1/2 z-10 -translate-y-1/2 transform p-1 md:p-2 hover:bg-opacity-100 transition-all duration-300"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <img 
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751994914/Arrow_drop_left_irbsyc.png" 
            alt="Next" 
            className="w-4 h-4 md:w-12 md:h-12 transform"
          />
        </button>

        <Swiper
          modules={[Autoplay, Navigation]}
          slidesPerView="auto"
          spaceBetween={20}
          slidesPerGroup={1}
          centeredSlides={false}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            320: { 
              slidesPerView: 3.2,
              spaceBetween: 2,
            },
            1024: { 
              slidesPerView: 3.5,
              spaceBetween: 4,
            },
          }}
        >
          {cardData.map((card, index) => (
            <SwiperSlide key={index} className="!w-[calc(100%/3.2)] md:!w-[calc(100%/3.5)]">
            <div className="md:w-[340px] w-[100px] h-[150px] md:h-[610px] md:rounded-[5px] rounded-[2px] relative overflow-hidden bg-cover bg-center cursor-pointer hover:scale-95 transition-transform duration-300"
        style={{ backgroundImage: `url(${card.image})` }}
        onClick={() => openVideoModal(card.video)}>
                <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                    alt="Play"
                    className="w-[25px] h-[25px] md:w-[100px] md:h-[100px] z-10 transition-transform duration-300 hover:scale-110"
                  />
                </div>

                <div className="absolute bottom-0 left-0 w-full h-full flex flex-col justify-end">
                  <div className="absolute bottom-0 w-full h-[40%] md:h-[35%] bg-[#986026] mix-blend-darken opacity-90 z-0"></div>
                  <div className="relative z-10 w-full md:p-4 p-1.5">
                    <div className='flex items-center justify-between'>
                      <h3 className="text-[6px] md:text-[22px] font-bold text-white px-2">{card.title}</h3>
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744202632/image_1538_bievzn.png"
                          alt="Logo"
                          className="w-[15px] h-[15px] md:mb-2 mb-0 sm:w-[10px] sm:h-[10px] md:w-[15px] md:h-[15px] xl:w-[25px] xl:h-[25px] object-contain"
                        />
                      </a>
                    </div>
                    <p className="text-[4px] md:text-[18px] font-normal text-white px-2">
                      {card.description}
                    </p>
                    <div className="flex items-center justify-between px-2 md:mt-2">
                      <div className="flex items-center gap-2">
                        <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744235659/image_20_ujukab.png"
                          alt="Location"
                          className="md:w-5 md:h-5 w-2 h-2"
                        />
                        <p className="text-white text-[4px] md:text-[14px] font-medium flex">
                          {card.location}
                        </p>
                      </div>
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744205132/Expand_right_unwap6.png"
                        alt="Person"
                        className="md:w-8 h-3 w-3 md:h-8"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      
      <a href="/voiceoffarmermain">
        <div className='flex justify-end'>
          <div className='flex md:gap-2 gap-1 justify-center mt-3 md:mb-2 md:mt-5 md:mr-0 mr-2'>
          <a
          href="/voiceoffarmermain"
          className="md:w-[220px] w-[80px] h-[15px] md:h-[50px] flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white shadow-xl"
          style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          <span className="flex-1 text-center">Go To</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
            alt="arrow"
            className="md:w-[23px] w-[12px] h-[14px] md:h-[21px] mr-1 md:mr-4"
          />
        </a>
          </div>
        </div>
      </a>

      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm"
          onClick={closeVideoModal}
        >
          <div
            ref={modalRef}
            className="relative w-[90vw] h-[70vh] md:w-[80vw] md:h-[80vh] bg-black rounded-xl overflow-hidden shadow-2xl transform transition-all duration-500 ease-out"
            style={{
              transform: 'scale(1) rotateY(0deg)',
              opacity: 1,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeVideoModal}
              className="absolute top-4 right-4 z-50 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-100 transition-all duration-300"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <div className="absolute inset-0 flex items-center justify-center bg-black">
              <video
                controls
                autoPlay
                className="w-full h-full object-contain"
                src={selectedVideo}
              />
            </div>
            
            <div className="absolute inset-0 border-4 border-[#986026] opacity-70 pointer-events-none"></div>
            <div className="absolute inset-0 border-8 border-[#2E453D] opacity-30 pointer-events-none"></div>
          </div>
        </div>
      )}

      <style jsx global>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-in-out;
        }
        
        @keyframes modalOpen {
          0% {
            transform: scale(0.8) rotateY(90deg);
            opacity: 0;
          }
          100% {
            transform: scale(1) rotateY(0deg);
            opacity: 1;
          }
        }
        
        @keyframes modalClose {
          0% {
            transform: scale(1) rotateY(0deg);
            opacity: 1;
          }
          100% {
            transform: scale(0.8) rotateY(90deg);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default VoiceOfFarmers;